//
// RangeBound.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../../lib";
import "../../GTLModel";
import "./RangeBoundType";

var RangeBound = createModule("gtl::RangeBound", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        inclusive: 2,
        type: 4,
        value: 6,
    },
    ,
    ,
    ,
    {
        _create_v: [4],
    },
    ,
    ["_create"]
]);
export default RangeBound;
